import React from 'react';
import { motion } from 'framer-motion';
import { Grid2x2, Home, Building2, Sprout, Trees, Lightbulb } from 'lucide-react';
type Service = {
  icon: React.ReactNode;
  title: string;
  description: string;
};
const SERVICES: Service[] = [{
  icon: <Sprout className="h-6 w-6" data-id="element-149" data-mp="o118rbezb0nb" />,
  title: 'Artificial Turf',
  description: 'Lush, water-wise turf that stays green year-round — perfect for yards, play areas, and pet spaces.'
}, {
  icon: <Grid2x2 className="h-6 w-6" data-id="element-150" data-mp="e2le4ygqt992" />,
  title: 'Pavers & Patios',
  description: 'Custom paver patios, walkways, and driveways built to last through Arizona summers.'
}, {
  icon: <Trees className="h-6 w-6" data-id="element-151" data-mp="549slauqh1nh" />,
  title: 'Desert Landscaping',
  description: 'Low-maintenance desert designs with palms, cacti, and native plantings that thrive in the heat.'
}, {
  icon: <Home className="h-6 w-6" data-id="element-152" data-mp="1zh9a59ioc5xe" />,
  title: 'Residential',
  description: 'Full backyard and front-yard makeovers that boost curb appeal and how you enjoy your home.'
}, {
  icon: <Building2 className="h-6 w-6" data-id="element-153" data-mp="18d92aazwpr6h" />,
  title: 'Commercial',
  description: 'Professional grounds for hotels, offices, and properties — installed clean and on schedule.'
}, {
  icon: <Lightbulb className="h-6 w-6" data-id="element-154" data-mp="zfgmz6u6qjj3" />,
  title: 'Hardscape & Lighting',
  description: 'Pergolas, shade structures, and low-voltage lighting that extend your outdoor living.'
}];
export function Services() {
  return <section id="services" className="w-full bg-background py-20 sm:py-24" data-id="element-155" data-mp="1w451vualtqoa">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-156" data-mp="1w3d90r8e671p">
        <div className="max-w-2xl" data-id="element-157" data-mp="1ibow4lqbjejo">
          <span className="text-sm font-semibold uppercase tracking-wider text-brand-red" data-id="element-158" data-mp="1ianjictnmjzu">
            What we do
          </span>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl" data-id="element-159" data-mp="2b1p10kktkrmj">
            Complete outdoor services, done right
          </h2>
          <p className="mt-4 text-lg text-muted-foreground" data-id="element-160" data-mp="2fu8gjn32hwtz">
            From the first design to the final detail, we handle every part of your
            project with quality that lasts.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-161" data-mp="2fpy5w9gu5deo">
          {SERVICES.map((service, i) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.05
        }} className="group rounded-2xl border border-border bg-card p-7 transition-all hover:-translate-y-1 hover:border-brand-red/40 hover:shadow-lg" data-id="element-162" data-mp="2armx822a18y1" data-mpi={i}>
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-navy text-white transition-colors group-hover:bg-brand-red" data-id="element-163" data-mp="1ry99oi0w84sg">
                {service.icon}
              </div>
              <h3 className="mt-5 font-heading text-lg font-semibold text-brand-ink" data-id="element-164" data-mp="1j21oj2dkqe2e">
                {service.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground" data-id="element-165" data-mp="2igshu2x5jxj">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}